import React from "react";
import BaseTextButton from "../../../../components/BaseTextButton";
import useAuth from "../../../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import LogoMobileApp from "../../../../assets/images/logo_mobile_app.png";
import MobileAppSelectLang from "../../../../components/MobileAppSelectLang";
import ROUTES from "../../../../utils/routes";
import isPayplusDomain from "../../../../utils/isPayplusDomain";
import "./style.scss";

export default function MobileAppSectionHeader() {
  const { token } = useAuth();
  const { t } = useTranslation();

  return (
    <section className="section-header-mobile">
      <div className="section-header-mobile__actions">
        {isPayplusDomain() && <MobileAppSelectLang />}
        <BaseTextButton
          icon="login"
          to={token ? ROUTES.PERSONAL_ACCOUNT_PAGE : ROUTES.LOGIN_PAGE}
          name="login"
          iconStyle="section-header-mobile__log-in-icon1 section-header-mobile__login-ic"
          className="section-header-mobile__log-in1 section-header-mobile__login-nav"
          iconWrapperStyle="section-header-mobile__log-in-icon-wrapper"
        >
          {token ? t("personal_account") : t("logIn")}
        </BaseTextButton>
      </div>
      <img
        src={LogoMobileApp}
        alt="logo"
        className="section-header-mobile__logo"
      />
    </section>
  );
}
